import { createRoot } from 'react-dom/client';

import { mountPreviewBar } from '@savgroup-front-common/core/components/PreviewBar/mountPreviewBar';
import '@savgroup-front-common/primitive/globals.css';

import { fetchAuthorityUrl } from './configuration';
import App from './view/app/App';

mountPreviewBar();

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container "#root" was not found in the document');
}

const root = createRoot(container);

fetchAuthorityUrl().then(() => {
  root.render(<App />);
});
